import React, { FC } from "react";

export const NotFound: FC = () => {
  return (
    <div className="wrapper-notFound">
      <h1 className="notFound">Error 404. Not found</h1>
    </div>
  );
};
